import gql from 'graphql-tag'

export default gql`
  query users_isAdminButton($id: ID!) {
    user(id: $id) {
      isAdmin
    }
  }
`
